const emailSupport = 'mailto:info@chpokify.com';

const openEmailModal = () => window.open(emailSupport);

const support = {
  openEmailModal,
};

export { support };
